import { IDescription } from './types';
import { mapDescription } from './mapDescription';
import { RichText } from 'prismic-reactjs';
import CustomPrismicLink from '@components/CustomPrismicLink';
import withSlice from '@screens/SlicesContainer/withSlice';

export const Description: React.FC<IDescription> = ({ description }) => {
  return (
    <>
      <div className="description">
        <RichText render={description} serializeHyperlink={CustomPrismicLink} />
      </div>
      <style jsx>{`
        .description > p {
          font-weight: var(--font-weight-bold);
        }
      `}</style>
    </>
  );
};

export default withSlice(Description, mapDescription);
